<template>
    <nav>
        <h2>En este programa</h2>
        <ul>
            <template v-for="node in nodes">
                <Node :node="node" :key="node.code" @update-tree="updateTree"/>
            </template>
        </ul>
    </nav>
</template>
<script>
import Node from './Node.vue'
export default {
    name: "Tree",
    props: {
        program: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            nodes: []
        }
    },
    created() {
        this.buildNodes()
    },
    methods: {
        buildNodes() {
            this.program.products.forEach(product => {
                const children = []
                product.activities.forEach(activity => {
                    children.push({
                        code: activity.code, 
                        title: activity.title, 
                        checked: true, parent: 
                        product.code
                    })
                });
                this.nodes.push({
                    code: product.code, 
                    title: product.title, 
                    checked: true, 
                    children: children
                })
            });
        },
        updateNode(node, checked) {
            node.checked = checked;
            this.$emit('update-visibility', node.code, checked)
        },
        findNode(code, nodes = this.nodes){
            for ( let i = 0; i < nodes.length ; i++) {
                if ( nodes[i].code == code ) {
                    return nodes[i];
                } else {
                    if ( nodes[i].children && nodes[i].children.length) {
                        var node = this.findNode(code, nodes[i].children)
                        if ( node ) return node;
                    }
                }
            }
        },
        updateChildren(node, checked){
            this.updateNode(node, checked)
            if(node.children && node.children.length) {
                for ( let i = 0; i < node.children.length ; i++) {
                    this.updateChildren(node.children[i], checked)
                }
            }
        },
        updateParent(node, checked){
            if ( node.parent ) {
                var parent = this.findNode(node.parent)
                let indeterminate = undefined
                parent.checked = undefined
                parent.children.forEach ( child => {
                    if ( child.code != node.code && child.checked != checked ) indeterminate = true
                })
                parent.indeterminate = indeterminate
                indeterminate ? parent.checked  = false : this.updateNode(parent, checked)
                if(parent.parent) this.updateParent(parent, checked)
            }
        },
        updateTree(code, checked){
            var node = this.findNode(code)
            if ( node.indeterminate ) node.indeterminate = undefined
            this.updateChildren(node, checked);
            this.updateParent(node, checked);
        },
    },
    components: { Node },
}
</script>